import { marqueeTips } from '@/mocks/site';

export default function TickerStrip() {
  const loop = [...marqueeTips, ...marqueeTips];

  return (
    <div className="overflow-hidden border-y border-background-200 bg-background-100 py-2.5">
      <div className="flex items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-flashlight-fill" />
          实时速报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee gap-8">
            {loop.map((tip, index) => (
              <span
                key={`${tip}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700"
              >
                <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
                {tip}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}